import { LabelText } from '@calendly/ui/components/typography'

import { FieldsContainer } from '../../elements'

export const Base = ({
  header,
  children,
}) => (
  <FieldsContainer>
    {header && <LabelText size="medium">{header}</LabelText>}
    {children}
  </FieldsContainer>
)
